import { Grid } from "@material-ui/core";
import styled from "styled-components";

export const FillerGrid = styled(Grid)`
  visibility: hidden;
  width: 0;
  padding-left: 0 !important;
  padding-right: 0 !important;
`;
